import { z } from 'zod';

export const ReportSchema = z.object({
  shop_id: z.string().uuid(),
  business_name: z.string(),
  notification_id: z.string().uuid().optional(),
});
